import React from 'react'
import { postActusParams } from '../../../types'
import 'swiper/css'
import dayjs from 'dayjs'
import style from './style.module.scss'
import clsx from 'clsx'
import { useEditor } from '@smartfire/js-block-engine'
import he from 'he'

export enum mobileType {
    classic = 'CLASSIC',
    archive = 'ARCHIVE',
    minify = 'MINIFY',
}

export const Tile: React.FC<{ post: postActusParams; mobile?: mobileType; isMobile?: boolean }> = ({
    post,
    mobile = mobileType.classic,
    isMobile,
}) => {
    const { isEditing } = useEditor()
    const thumbnailTag =
        isMobile && post.thumbnail_mobile ? post.thumbnail_mobile?.tag : post.thumbnail.tag

    return (
        <div className={clsx(style.block, style[mobile], isEditing ? style.admin : undefined)}>
            <div className={style.top}>
                <a href={post.link} className={style.imageContainer}>
                    {thumbnailTag && <picture dangerouslySetInnerHTML={{ __html: thumbnailTag }} />}
                </a>

                <div className={style.content}>
                    <div className={style.taxs}>
                        {post.parentTax && (
                            <a className={style.ptax} href={post.parentTax.link}>
                                {post.parentTax.name}
                            </a>
                        )}
                        {post.tax && post.parentTax && '/'}
                        {post.tax && (
                            <a className={style.ctax} href={post.tax.link}>
                                {post.tax.name}
                            </a>
                        )}
                    </div>

                    <a className={style.title} href={post.link}>
                        {post.title}
                    </a>

                    <a className={style.excerpt} href={post.link}>
                        {he.decode(post.excerpt)}
                    </a>
                </div>
            </div>

            <div className={style.bottomContainer}>
                <div className={style.bottom}>
                    <p className={style.date}>{dayjs(post.date).format('DD MMM YYYY')}</p>

                    <p className={style.readingTime}>
                        <i className={clsx('fi fi-rs-stopwatch', style.icon)} />
                        {post.readingTime}
                        &nbsp;MIN.
                    </p>
                </div>
            </div>
        </div>
    )
}
